<script setup>
import { computed } from "vue";
import ProgressBar from './ProgressBar.vue'
import { bytesToMegabytes } from "@/Mixins/filesizeCalculator";

const props = defineProps({
    file: {
        type: Object,
        default: () => {},
        required: true,
    },
});

const emit = defineEmits([
	'upload-complete'
])

//convert bytes to MB
const fileSize = computed(() => {
	return bytesToMegabytes(props.file.size);
})

//helper functions to monitor upload status and manage animation
const uploadProgress = computed(() => {
    if (props.file.progress === 1) {
		emit('upload-complete', props.file)
        return "Uploaded"
    } else return parseInt(props.file.progress * 100).toString() + '%'
});


</script>

<template>
    <div
        class="
            bg-slate-100
            p-4
            my-4
            rounded-lg
            box-border
            flex
            justify-center
            items-center
            px-4
			shadow
        "
    >
        <div class="w-full">
            <div class="grid grid-cols-2">
                <h2>{{ props.file.name }}</h2>
                <div class="flex w-full justify-between">
					<p>{{fileSize}}</p>
                    <p>{{ uploadProgress }}</p>
                </div>
            </div>
           <ProgressBar :progress='props.file.progress' />
        </div>
    </div>
</template>
